import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';

@Component({
    selector: 'emm-delete-item-dialog',
    styleUrls: ['./delete-item-dialog.component.scss'],
    templateUrl: './delete-item-dialog.component.html'
})
export class DeleteItemDialogComponent implements OnInit {
    isReadOnly$ = this.authFacade.isReadOnly$;
    itemTag: string;

    constructor(
        public dialogRef: MatDialogRef<DeleteItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public authFacade: AuthFacadeService
    ) {
        this.itemTag = data.tag;
    }


    ngOnInit(): void {
    }


    cancelDeleteItem(): void {
        this.dialogRef.close();
    }


    deleteItem(): void {
        this.dialogRef.close(true);
    }


}
